import { useState } from 'react';

import { styled } from '../../../stitches.config';
import {
  Button,
  ButtonProps,
  Tooltip,
  TooltipTrigger,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
} from '../../../components';

const IconText = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$3',
});

export async function copyToClipboard(text: string) {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error('Failed to use clipboard API:', error);
    }
  } else {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text.replace(/\n/gi, '\r\n');
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  }
}

type ButtonCopyProps = ButtonProps & {
  copy: string;
  tooltipText?: string;
  stopPropagation?: boolean;
};

export const ButtonCopy = (props: ButtonCopyProps) => {
  const { copy, tooltipText, stopPropagation, ...buttonProps } = props;
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const onClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (stopPropagation) {
      event.stopPropagation();
    }

    await copyToClipboard(copy);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <TooltipProvider>
      <Tooltip
        delayDuration={300}
        open={copied || open}
        onOpenChange={open => {
          if (!copied) {
            setOpen(open);
          }
        }}
      >
        <Button as={TooltipTrigger} onClick={onClick} {...buttonProps} icon={copied ? 'done' : 'content_copy'} />
        <TooltipContent sideOffset={5}>
          {copied ? <IconText>Copied</IconText> : tooltipText ?? copy}

          <TooltipArrow />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
